import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReminderService {

  private reminderIdSource = new BehaviorSubject<string | null>(null);
  reminderId$ = this.reminderIdSource.asObservable();

  private refreshSource = new Subject<void>();
  refresh$ = this.refreshSource.asObservable();

  setReminderId(reminderId: string) {
    this.reminderIdSource.next(reminderId);
  }

  triggerRefresh() {
    this.refreshSource.next();
  }
}
